<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'updateCurrentSocketMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const updateCurrentSocketMutation = gql`
      mutation($userDataId: ID!, $currentSocket: String!) {
        updateUserData(id: $userDataId, data: { currentSocket: $currentSocket }) {
          data {
            attributes {
              session
            }
          }
        }
      }
      `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: updateCurrentSocket } = useMutation(updateCurrentSocketMutation, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'updateCurrentSocket', result: updateCurrentSocket });
  },
};
</script>
